"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getPathFromRoute_exports = {};
__export(getPathFromRoute_exports, {
  getPathFromRoute: () => getPathFromRoute
});
module.exports = __toCommonJS(getPathFromRoute_exports);
var import_getPathnameFromFilePath = require("../../utils/getPathnameFromFilePath");
function getPathFromRoute(route) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var params = {};
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = route.file.matchAll(/\[([^\]]+)\]/g)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var [param, inner] = _step.value;
      params[inner] = param;
      params[inner.replace(/^\.\.\./, "")] = param;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return (0, import_getPathnameFromFilePath.getPathnameFromFilePath)(route.file, params, false, {
    ...options,
    preserveExtensions: true
  }).replace(/^\.\//, "/").replace(/\/+$/, "");
}
//# sourceMappingURL=getPathFromRoute.js.map
